import { useEffect, useMemo, useState } from "react";
import { FaBalanceScale, FaBuilding, FaIndustry, FaLeaf, FaSitemap } from "react-icons/fa";
import { FiDatabase } from "react-icons/fi";
import { GrCompliance } from "react-icons/gr";
import { MdBusiness, MdEco, MdHub } from "react-icons/md";
import { PiMedal } from "react-icons/pi";
import CommonSidebar from "../../app_components/CommonSidebar";
import { useContextProvider } from "../../components/page-context/ContextProvider";
import routing from "../../routing";

const OrganizationSideBar = () => {
  const { selectedSupplyChains, selectedSupplyChainId, selectedStructures, selectedStructureId, selectedCorporateId } = useContextProvider();
  const user = useMemo(() => JSON.parse(localStorage.getItem("user")), []);
  const is_organization_enabled = useMemo(() => user["is_organization_enabled"] === 1, [user]);
  const hasSelectedSupplyChain = useMemo(() => selectedSupplyChainId !== null, [selectedSupplyChainId]);
  const hasSelectedStructure = useMemo(() => selectedStructureId !== null, [selectedStructureId]);
  const hasSelectedCorporate = useMemo(() => selectedCorporateId !== null, [selectedCorporateId]);

  const [supplyChainPulse, setSupplyChainPulse] = useState(0);
  const [structurePulse, setStructurePulse] = useState(0);
  const [isWorkspaceActive, setIsWorkspaceActive] = useState(false);

  useEffect(() => {
    if (selectedSupplyChains.length > 0) {
      setSupplyChainPulse((p) => p + 1);
      setIsWorkspaceActive(true);
      const timer = setTimeout(() => setIsWorkspaceActive(false), 10000);
      return () => clearTimeout(timer);
    }
  }, [selectedSupplyChains]);

  useEffect(() => {
    if (selectedStructures.length > 0) {
      setStructurePulse((p) => p + 1);
      setIsWorkspaceActive(true);
      const timer = setTimeout(() => setIsWorkspaceActive(false), 10000);
      return () => clearTimeout(timer);
    }
  }, [selectedStructures]);

  const tabs = useMemo(
    () => [
      {
        label: "Supply Chain",
        value: "supply_chain",
        icon: MdHub,
        subHeader: "Features",
        rootPath: routing.organization.supply_chain.root,
        path: routing.organization.supply_chain.dashboard,
        visibility: is_organization_enabled,
        subTabs: [
          { label: "Dashboard", value: "dashboard", icon: FaSitemap, path: routing.organization.supply_chain.dashboard, visibility: true },
          { label: "Workspace", value: "workspace", icon: FiDatabase, path: routing.organization.supply_chain.workspace, visibility: hasSelectedSupplyChain, pulse: supplyChainPulse, showBorder: isWorkspaceActive },
          { label: "Comparison", value: "comparison", icon: FaBalanceScale, path: routing.organization.supply_chain.comparison, visibility: true },
        ],
      },
      {
        label: "Organization",
        value: "organization",
        icon: FaBuilding,
        subHeader: "Features",
        rootPath: routing.organization.structure.root,
        path: routing.organization.structure.dashboard,
        visibility: is_organization_enabled,
        subTabs: [
          { label: "Dashboard", value: "dashboard", icon: FaIndustry, path: routing.organization.structure.dashboard, visibility: true },
          { label: "Workspace", value: "workspace", icon: FiDatabase, path: routing.organization.structure.workspace, visibility: hasSelectedStructure, pulse: structurePulse, showBorder: isWorkspaceActive },
          { label: "Comparison", value: "comparison", icon: FaBalanceScale, path: routing.organization.structure.comparison, visibility: true },
        ],
      },
      {
        label: "Sustainability",
        value: "sustainability",
        icon: MdEco,
        subHeader: "Features",
        rootPath: routing.organization.sustainability.root,
        path: routing.organization.sustainability.net_zero,
        visibility: true,
        subTabs: [
          {
            label: "Net Zero",
            value: "net_zero",
            icon: FaLeaf,
            path: routing.organization.sustainability.net_zero,
            visibility: true,
          },
        ],
      },
      {
        label: "Compliance",
        value: "compliance",
        icon: GrCompliance,
        subHeader: "Features",
        rootPath: routing.organization.compliance.root,
        path: routing.organization.compliance.sbti,
        visibility: true,
        subTabs: [
          {
            label: "SBTI",
            value: "sbti",
            icon: PiMedal,
            path: routing.organization.compliance.sbti,
            visibility: true,
          },
          {
            label: "CDP",
            value: "cdp",
            icon: PiMedal,
            path: routing.organization.compliance.cdp,
            visibility: true,
          },
          {
            label: "EcoVadis",
            value: "eco_vadis",
            icon: PiMedal,
            path: routing.organization.compliance.eco_vadis,
            visibility: true,
          },
        ],
      },
    ],
    [is_organization_enabled, hasSelectedSupplyChain, hasSelectedStructure, supplyChainPulse, structurePulse, isWorkspaceActive]
  );

  return <CommonSidebar tabs={tabs}></CommonSidebar>;
};

export default OrganizationSideBar;
